<template lang="pug">
    div
        div(v-if="dataLoader || dataLoader1 || campLoader")
            Loader 
        div.summaryContainer
            div(class="tw-flex tw-justify-between tw-items-center tw-bg-[#fff] tw-rounded-[0.7rem] tw-mb-[1rem] tw-p-[1rem] tw-my-4 2xl:tw-text-base xl:tw-text-sm") 
              div.tw-flex.tw-gap-4
                div
                    div(class="tw-text-sm tw-ml-1 tw-mb-1 tw-text-[#1e1e1e]") Date Range
                    date-range-picker.customDateRange(v-model="alertDateRange"
                        opens='right'
                        :autoApply="true"
                        :locale-data="{format:'dd mmm yyyy'}"
                        @update="handleDateChange"
                        :show-dropdowns="true"
                    )
                div.customMultiselectCommon(class="2xl:tw-w-48 tw-w-36 tw-mb-2 tw-text-sm") 
                    div(class="tw-text-sm tw-ml-1 tw-mb-1 tw-text-[#1e1e1e]") Channel    
                    multiselect(
                        v-model="selectedChannel"
                        :options="channelList"
                        placeholder="Select Channel"
                        track-by="key" 
                        label="label"
                        :searchable="false"
                        :show-labels="false"
                        open-direction="bottom" 
                        :multiple="false"
                        :allow-empty="false"
                        :close-on-select="true"
                        @input="handleChannel"
                    )
              button(class="navigationButton" @click="handleBack")  Back

            div.card.tw-mb-4
                div.tw-flex.tw-justify-between.tw-text-primary_brand.tw-font-medium.tw-mb-3.tw-pb-2(style="border-bottom:1px solid #D4D4D4")
                    div.tw-text-primary_brand.tw-items-center(class="tw-text-[16px] tw-font-semibold tw-tracking-wide") Rules
                    button(class="navigationButton" @click="addButton") Add Rule
                div(v-if="rulesTableData.length")
                    table#ruleTable.tw-w-full
                        thead.tw-w-full
                            tr.tw-w-full
                                th(v-for="head in rulesTableHeader")
                                  div(class="tw-text-center") {{ head.label }}
                        tbody
                            tr(v-for="rowData in rulesTableData")
                                td(v-for="head in rulesTableHeader" v-if="head.key !== 'action'" )
                                  div(class="tw-text-center") {{ rowData[head.key] }}
                                td(v-for="head in rulesTableHeader" v-if="head.key === 'action'" class="tw-flex tw-gap-4 tw-justify-center") 
                                  img(src="Icons_SVG/deleteBtnSvg.svg" @click='handleDeleteRule(rowData.rule_id)' class="tw-cursor-pointer")
                                  img(src="Icons_SVG/editBtn.svg" @click='handleUpdateRule(rowData)' class="tw-cursor-pointer")
                div(class="onLoadingData tw-mt-4" v-else-if="isRuleTableDataLoader && !rulesTableData.length") Loading... 
                div(class="tw-text-danger tw-flex tw-justify-center tw-border tw-border-danger tw-rounded tw-mt-4 tw-p-2 noData" v-else) No Data Available

            div.card.tw-mt-4
                div.tw-flex.tw-justify-between.tw-mb-3.tw-text-primary_brand.tw-font-medium.tw-pb-2(style="border-bottom:1px solid #D4D4D4")
                    div.tw-text-primary_brand.tw-items-center(class="tw-text-[16px] tw-font-semibold tw-tracking-wide") Alerts
                    button(class="navigationButton" @click="addCampButton")  Set Alerts
                div(v-if="campaignTableData.length>0")
                  table#campaignRuleTable.tw-w-full
                      thead
                          tr
                              th(v-for="head in campaignTableHeader")
                                div(class="tw-text-center") {{ head.label }}
                              th
                                div(class="tw-text-center") Action
                      tbody
                          tr(v-for="rowData in campaignTableData")
                              td(v-for="head in campaignTableHeader") 
                                div(v-if="head.key!='campaign_name' && head.key!='rule_names' && head.key!='campaign_type' && head.key!='email' && head.key!='run_at' &&head.key !='interval'" class="tw-text-center") {{ rowData[head.key] }}    
                                
                                div(class="2xl:tw-max-h-[58px] tw-max-h-[48px] 2xl:tw-max-w-[200px] tw-text-center tw-max-w-[150px] tw-py-1 tw-overflow-auto")
                                    div.mb-1(v-if="head.key=='campaign_name'" v-for="data of rowData.campaign_name" class="tw-truncate") 
                                        span(class="tw-px-2 tw-py-1 tw-bg-primary_brand-80 text-white tw-text-xs tw-font-medium tw-rounded-full" :title='data') {{ data }}
                                
                                div(class="2xl:tw-max-h-[55px] tw-max-h-[48px] tw-max-w-[100px] tw-overflow-auto tw-text-center")
                                    div.mb-1( v-if="head.key=='rule_names'" class= "tw-truncate" v-for="data of rowData.rule_names") 
                                        span(class="tw-px-2 tw-py-1 tw-bg-primary_brand-80  text-white tw-text-xs tw-font-medium tw-rounded-full" :title='data') {{ data }}
                                
                                div(class="2xl:tw-min-w-[80px] tw-min-w-[50px] 2xl:tw-max-h-[55px] tw-max-h-[48px] tw-overflow-auto tw-text-center")
                                    div.tw-mb-1(v-if="head.key=='run_at'" class="tw-flex tw-flex-wrap tw-text-center") 
                                        div(v-for="data of rowData.run_at")
                                            span(class="tw-p-1 tw-text-xs tw-font-medium ") {{ data }}
                                
                                div(class="2xl:tw-max-h-[55px] tw-max-h-[48px] tw-max-w-[100px] tw-overflow-auto tw-text-center")
                                    div.tw-mb-1(v-if="head.key=='campaign_type'" v-for="data of rowData.campaign_type" class="tw-truncate")
                                        span.tw-text-xs(class="tw-px-2 tw-py-1 tw-bg-primary_brand-80 tw-capitalize  text-white tw-text-xs tw-font-medium tw-rounded-full") {{ data }}
                                
                                div
                                    div.tw-mb-1(v-if="head.key=='email'" v-for="data of rowData?.email" class="tw-mb-2 truncate tw-text-center")
                                        span.tw-text-xs(class="tw-px-2 tw-py-1 tw-bg-primary_brand-80 text-white tw-my-3 tw-text-xs tw-font-medium tw-rounded-full") {{ data }}
                                
                                div
                                    div.tw-mb-1(v-if="head.key=='interval'" class="tw-capitalize tw-text-center") {{ rowData[head.key] }}  
                                       
                              td
                                div.tw-flex.tw-gap-3.tw-justify-center
                                  img(src="Icons_SVG/deleteBtnSvg.svg" @click='handleDeleteAlert(rowData.alert_id)' class="tw-cursor-pointer")
                                  img(src="Icons_SVG/editBtn.svg" @click='handleUpdateAlert(rowData)' class="tw-cursor-pointer")

                div(v-else-if="isCampaignTableDataLoader && !campaignTableData.length" class="onLoadingData tw-mt-4") Loading...
                div(class="tw-text-danger tw-flex tw-justify-center tw-border tw-border-danger tw-rounded tw-mt-4 tw-p-2 noData" v-else) No Data Available

            div.card.tw-mt-4
                div.tw-mb-4.tw-pb-2(style="border-bottom:1px solid #D4D4D4")
                    div.tw-text-primary_brand(class="tw-text-[16px] tw-font-semibold tw-tracking-wide") Reports
                    
                table#reportsTable.tw-w-full(v-if="alertCampReports.headers.length")
                    thead
                        tr
                            th(v-for="head of alertCampReports.headers")
                              div(class="tw-text-center") {{ head.label }}
                    tbody
                        tr(v-for="rowData of alertCampReports.data")
                          td(v-for="head of alertCampReports.headers") 
                            div(v-if="head.key === 'report_name'" class=" tw-cursor-pointer tw-text-center" @click="getFailedCampaigns(rowData[head.key])") {{ rowData[head.key] }}    
                            div(v-else class="tw-text-center") {{ rowData[head.key] }}

                div(v-else-if="isAlertCampReportLoader  && !alertCampReports.headers.length" class="onLoadingData tw-mt-4") Loading...
                div(class="tw-text-danger tw-flex tw-justify-center tw-border tw-border-danger tw-rounded tw-mt-4 tw-p-2 noData" v-else) No Data Available

        div#rule-modal.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-right-0.tw-p-4.tw-h-modal.tw-max-h-full.tw-rounded-lg(v-if="isRuleModel" style ="z-index:1020" tabindex='-1' ref="ruleModal" class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9397]' )
            div(class="bg-white tw-border-[#d4d4d4] tw-border-[1px] tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px]  tw-w-1/2 tw-pb-0")
                div.tw-relative.tw-bg-white.tw-rounded-lg
                    div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-4.tw-mb-4(class="tw-border-[#d5d5d5]")
                        div.tw-capitalize(class="2xl:tw-text-[20px] xs:tw-text-sm") Create AMS Rule 
                        div.tw-cursor-pointer(@click="hideRuleModal()" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                            i(class="fa fa-solid fa-close  tw-text-[#000] tw-text-[20px]")   
                    div(v-for="(rule,idx) in rules" :key="idx" class="tw-mb-4 tw-mx-5")
                        div(class="2xl:tw-text-base xl:tw-text-sm tw-mb-4 tw-text-[#5E5E5E]") 
                            div.tw-mb-2 Rule Name
                            input.tw-px-3.tw-mr-10.tw-mb-2.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 tw-border-[#B3B2B9] xl:tw-h-7 focus:tw-border-[#B3B2B9] sm:tw-h-7 xs:tw-h-7 tw-w-full focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="rule.rule_name" placeholder="Rule name")
                        div
                            div(v-for="(item, index) in rules[idx].conditions" :key="index" class="tw-mb-1 tw-flex tw-items-center")
                                div.customMultiselectCommon.tw-mr-4(class="2xl:tw-text-base xl:tw-text-sm tw-w-1/3 tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Select Metric
                                    multiselect(
                                        v-model="item.metric"
                                        :options="metrics"
                                        placeholder="Select metric"
                                        :searchable="true"
                                        :show-labels="false" 
                                        :multiple="false"
                                        open-direction="bottom"
                                        :allow-empty="false"
                                    )
                                div.customMultiselectCommon.tw-mr-4(class="2xl:tw-text-base xl:tw-text-sm tw-w-1/3 tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Condition
                                    multiselect(
                                        v-model="item.operation"
                                        :options="dropdownOptions2"
                                        placeholder="Select condition"
                                        :searchable="true"
                                        :show-labels="false" 
                                        :multiple="false"
                                        open-direction="bottom"
                                        :allow-empty="false"
                                        class="tw-py-0"
                                    )

                                //- input.h-10.bg-gray-50.border.w-60.border-solid.border-gray-300.text-gray-900.text-sm.rounded-md.block.pl-4( class='focus:ring-0 focus:border-primary_brand-40 p-2.5' v-model="details" placeholder='Modify details' ) 
                                div(class="2xl:tw-text-base xl:tw-text-sm tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Enter Value 
                                    input.tw-px-3.tw-mr-3.tw-bg-white.tw-border-solid.tw-border.tw-rounded.tw-block(class='3xl:tw-h-9 xl:tw-h-8 sm:tw-h-7 xs:tw-h-7 2xl:tw-w-56 xl:tw-w-48 tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-border-[#B3B2B9] focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="item.value" type="number" placeholder="Value")
                                button.tw-font-bold.tw-rounded-full.tw-mt-8.tw-text-center.tw-inline-flex.tw-items-center(class="tw-bg-[#0655591A] tw-text-[#065559] 2xl:tw-px-3 tw-px-2 xl:tw-h-7 2xl:tw-h-9 lg:tw-h-7 sm:tw-h-7 xs:tw-h-6 xs:tw-text-3xs" @click="removeItem(idx,index)" v-if="index > 0") 
                                    i(class="fa fa-solid fa-close") 
                                button.tw-cursor-pointer.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded-md.tw-mt-8.tw-text-center.tw-inline-flex.tw-items-center(class="hover:tw-bg-primary_brand-80 2xl:tw-px-3 tw-px-2 xl:tw-h-7 2xl:tw-h-9 lg:tw-h-7 xl:tw-text-xs 2xl:tw-text-sm lg:tw-text-xs sm:tw-text-xs sm:tw-h-7 xs:tw-h-6 xs:tw-text-3xs")(@click="addItem(idx)" v-if="index === 0") 
                                    i(class="fa fa-solid fa-plus")
                footer.tw-flex.tw-justify-end.tw-rounded-lg(class="tw-sticky tw-bottom-0 tw-bg-white tw-w-full tw-py-4 tw-mb-0 tw-px-4")
                  button(class="primarycolor btn"  @click='postAlertRules()') 
                    span Submit

        div.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-right-0.tw-p-4.tw-h-modal.tw-max-h-full.tw-rounded-lg(v-if="isUpdateRuleModel" style ="z-index:1020" tabindex='-1' ref="ruleModal" class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9397]' )
            div(class="bg-white tw-border-[#d4d4d4] tw-border-[1px] tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px]  tw-w-1/2 tw-pb-0")
                div.tw-relative.tw-bg-white.tw-rounded-lg
                    div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-4.tw-mb-4(class="tw-border-[#d5d5d5]")
                        div.tw-capitalize(class="2xl:tw-text-[20px] xs:tw-text-sm") Update AMS Rule 
                        div.tw-cursor-pointer(@click="hideUpdateRuleModal()" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                            i(class="fa fa-solid fa-close  tw-text-[#000] tw-text-[20px]")   
                    div(v-for="(rule,idx) in updateRules" :key="idx" class="tw-mb-4 tw-mx-5")
                        div(class="2xl:tw-text-base xl:tw-text-sm tw-mb-4 tw-text-[#5E5E5E]") 
                            div.tw-mb-2 Rule Name
                            input.tw-px-3.tw-mr-10.tw-mb-2.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 tw-border-[#B3B2B9] xl:tw-h-7 focus:tw-border-[#B3B2B9] sm:tw-h-7 xs:tw-h-7 tw-w-full focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="updateRules.rule_name" placeholder="Rule name")
                        div
                            div(v-for="(item, index) in updateRules.conditions" :key="index" class="tw-mb-1 tw-flex tw-items-center")
                                div.customMultiselectCommon.tw-mr-4(class="2xl:tw-text-base xl:tw-text-sm tw-w-1/3 tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Select Metric
                                    multiselect(
                                        v-model="item.metric"
                                        :options="metrics"
                                        placeholder="Select metric"
                                        :searchable="true"
                                        :show-labels="false" 
                                        :multiple="false"
                                        open-direction="bottom"
                                        :allow-empty="false"
                                    )
                                div.customMultiselectCommon.tw-mr-4(class="2xl:tw-text-base xl:tw-text-sm tw-w-1/3 tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Condition
                                    multiselect(
                                        v-model="item.operation"
                                        :options="updateDropdownOptions2"
                                        placeholder="Select condition"
                                        :searchable="true"
                                        :show-labels="false" 
                                        :multiple="false"
                                        track-by="key"
                                        label="label"
                                        open-direction="bottom"
                                        :allow-empty="false"
                                        class="tw-py-0"
                                    )

                                //- input.h-10.bg-gray-50.border.w-60.border-solid.border-gray-300.text-gray-900.text-sm.rounded-md.block.pl-4( class='focus:ring-0 focus:border-primary_brand-40 p-2.5' v-model="details" placeholder='Modify details' ) 
                                div(class="2xl:tw-text-base xl:tw-text-sm tw-text-[#5E5E5E]")
                                    div.tw-mb-2 Enter Value 
                                    input.tw-px-3.tw-mr-3.tw-bg-white.tw-border-solid.tw-border.tw-rounded.tw-block(class='3xl:tw-h-9 xl:tw-h-8 sm:tw-h-7 xs:tw-h-7 2xl:tw-w-56 xl:tw-w-48 tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-border-[#B3B2B9] focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="item.value" type="number" placeholder="Value")
                                //- button.tw-font-bold.tw-rounded-full.tw-mt-8.tw-text-center.tw-inline-flex.tw-items-center(class="tw-bg-[#0655591A] tw-text-[#065559] 2xl:tw-px-3 tw-px-2 xl:tw-h-7 2xl:tw-h-9 lg:tw-h-7 sm:tw-h-7 xs:tw-h-6 xs:tw-text-3xs" @click="removeUpdateItem(idx,index)" v-if="index > 0") 
                                //-     i(class="fa fa-solid fa-close") 
                                //- button.tw-cursor-pointer.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded-md.tw-mt-8.tw-text-center.tw-inline-flex.tw-items-center(class="hover:tw-bg-primary_brand-80 2xl:tw-px-3 tw-px-2 xl:tw-h-7 2xl:tw-h-9 lg:tw-h-7 xl:tw-text-xs 2xl:tw-text-sm lg:tw-text-xs sm:tw-text-xs sm:tw-h-7 xs:tw-h-6 xs:tw-text-3xs")(@click="addUpdateItem(idx)" v-if="index === 0") 
                                //-     i(class="fa fa-solid fa-plus")
                footer.tw-flex.tw-justify-end.tw-rounded-lg(class="tw-sticky tw-bottom-0 tw-bg-white tw-w-full tw-py-4 tw-mb-0 tw-px-4")
                  button(class="primarycolor btn"  @click='updateAlertRules()') 
                    span Submit

        div#camp-modal.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-rounded-lg.tw-right-0.tw-p-4.tw-h-modal.tw-rounded-lg.tw-max-h-full(v-if="isAlertModel" style="z-index: 1020" tabindex='-1' class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9355]')
            div(class="bg-white  tw-border-[#d4d4d4] tw-border-[1px] tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px] tw-w-1/2 tw-pb-0")
                div.tw-relative.tw-bg-white.tw-rounded-lg
                    div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-4.tw-mb-4(class="tw-border-[#d5d5d5]")
                        div.tw-capitalize(class="2xl:tw-text-[20px] xs:tw-text-sm") Set Alerts     
                        div.tw-cursor-pointer(@click="hideCampModal()" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                          i(class="fa fa-solid fa-close   tw-text-[#000] tw-text-[20px]")   

                    div.tw-rounded-lg(class="tw-mb-4 tw-px-4")
                        div
                            div(v-if="dataLoader")
                                Loader   
                            <!-- div.step-content.text-xl.pb-5.font-semibold(v-if="currentActive === 1") Step 1: Alert Details -->
                            div
                                div(v-for="(camp,campIndex) in camp_rules" :key='campIndex' class="tw-grid tw-grid-cols-2 tw-gap-2 2xl:tw-text-base xl:tw-text-sm tw-text-[#5E5E5E]")  
                                    div
                                        div Alert Name 
                                        input.tw-px-1.tw-mr-2.tw-w-full.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-7 sm:tw-h-7 xs:tw-h-7 2xl:tw-text-sm xl:tw-text-xs tw-py-[15px] tw-border-[#B3B2B9] focus:tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="camp.alertName"  placeholder="Alert Name")
                                    div
                                        div Select Rule 
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-if='campIndex==0'
                                                v-model="camp.rule_id"
                                                :options="campaignRules"
                                                limit="1"
                                                placeholder="Select rule"
                                                track-by="rule_id" 
                                                label="rule_name"
                                                :searchable="true"
                                                :show-labels="false" 
                                                open-direction="bottom"
                                                :multiple="true"
                                                :allow-empty="true"
                                            )
                                              template(slot="option" slot-scope="{ option }")
                                                input(type="checkbox", :value="option" v-model="camp.rule_id")
                                                span(class="option__title tw-ml-3") {{ option.rule_name }}
                                        <!-- button.w-7.text-white.bg-primary_brand.font-medium.rounded-lg.px-2.text-center.inline-flex.items-center.ml-3(class="hover:bg-primary_brand-80 xl:h-7 2xl:h-9 lg:h-7 xl:text-xs 2xl:text-sm lg:text-xs sm:text-xs sm:h-7 xs:h-6 xs:text-3xs")(@click="addRuleButton" ) 
                                            font-awesome-icon(icon="fa-solid fa-add") -->
                                    div
                                        div  Campaign Type
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.campaign_type"
                                                :options="campaignType"
                                                placeholder="Select Campaign Type"
                                                limit="1"
                                                track-by="label" 
                                                label="key"
                                                :searchable="true"
                                                :show-labels="false"
                                                open-direction="bottom" 
                                                :multiple="true"
                                                :allow-empty="true"
                                                @input="getCampaign(camp.campaign_type)"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.campaign_type")
                                                    span(class="option__title tw-ml-3") {{ option.key }}
                                    div
                                        div Select Campaign
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.camp_id"
                                                :options="campaign"
                                                placeholder="Select Campaign"
                                                track-by="camp_id" 
                                                label="camp_name"
                                                :searchable="true"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="true"
                                                :allow-empty="true"
                                                :close-on-select="false"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.camp_id")
                                                    span(class="option__title tw-ml-3") {{ option.camp_name }}
                                    div
                                        div Date range 
                                        div
                                            div.customMultiselectCommon
                                                multiselect(
                                                    v-model="camp.radioSelcted"
                                                    :options="dateRangeInterval"
                                                    placeholder="Select date range"
                                                    :searchable="true"
                                                    track-by="label"
                                                    label="label"
                                                    :show-labels="false" 
                                                    :multiple="false"
                                                    open-direction="bottom"
                                                    :allow-empty="false"
                                                )
                                                    
                                            <!-- div -->
                                                <!-- input(type="radio" value="0" name="date" v-model="camp.radioSelcted"  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Today -->
                                            <!-- div -->
                                                <!-- input#default-radio-1(type="radio" v-model="camp.radioSelcted" value="1"  name="date" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600") 
                                                label.font-medium.ml-2 Days -->
                                        div.customMultiselectCommon.tw-mt-2(v-if='camp?.radioSelcted?.key==1')
                                            multiselect(
                                                v-model="camp.selectedLastDate"
                                                :options="LastDate"
                                                placeholder="Select Day"
                                                :searchable="true"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="false"
                                                :allow-empty="false"

                                            )
                                    div
                                        div Select interval
                                        div
                                            div.customMultiselectCommon
                                                multiselect(
                                                    v-model="camp.intervalSelected"
                                                    :options="dayInterval"
                                                    placeholder="Select date range"
                                                    track-by="label"
                                                    label="label"
                                                    :searchable="true"
                                                    :show-labels="false" 
                                                    :multiple="false"
                                                    open-direction="bottom"
                                                    :allow-empty="false"
                                                )
                                            <!-- div
                                                input#default-radio-1(type="radio" value="daily" v-model="camp.intervalSelected"  name="today" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Daily -->
                                            div
                                                <!-- input#default-radio-1(type="radio" name="today" value="weekly" v-model="camp.intervalSelected" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Weekly -->
                                                div.customMultiselectCommon.tw-mt-2(v-if="camp.intervalSelected && camp.intervalSelected.key=='weekly'")
                                                    multiselect(
                                                        v-model="camp.selectedLastDay"
                                                        :options="LastDay"
                                                        placeholder="Select Day"
                                                        :searchable="true"
                                                        open-direction="bottom"
                                                        :show-labels="false" 
                                                        :multiple="false"
                                                        :allow-empty="false"
                                                    )
                                            div
                                                <!-- input#default-radio-1(type="radio" value="monthly" v-model="camp.intervalSelected" name="today" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Monthly -->

                                                div.customMultiselectCommon.tw-mt-2(v-if="camp.intervalSelected && camp.intervalSelected.key=='monthly'")
                                                    multiselect(
                                                        v-model="camp.selectedLastMonth"
                                                        :options="LastDate"
                                                        placeholder="Select Date"
                                                        :searchable="true"
                                                        open-direction="bottom"
                                                        :show-labels="false" 
                                                        :multiple="false"
                                                        :allow-empty="false"
                                                    )

                                    div
                                        div Run at
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.time"
                                                :options="runTimes"
                                                placeholder="Select Run Time"
                                                limit="1"
                                                :searchable="false"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="true"
                                                :allow-empty="true"
                                                :close-on-select="false"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.time")
                                                    span(class="option__title tw-ml-3") {{ option }}
                                        //- input.tw-px-1.tw-mb-4.tw-bg-white.tw-border-solid.tw-border.tw-border-primary_brand-80.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-7 sm:tw-h-7 xs:tw-h-7 2xl:tw-w-56 xl:tw-w-48 2xl:tw-text-sm xl:tw-text-xs focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' type='time' v-model="camp.time"  )
                                    div
                                        div Email
                                        div
                                            input.tw-px-1.tw-mb-2.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-8 sm:tw-h-7 xs:tw-h-7 tw-py-[15px] tw-w-full 2xl:tw-text-sm xl:tw-text-xs tw-border-[#B3B2B9] focus:tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed '   v-model="tempEmail"  @keyup.enter="multipleEmail(campIndex)" placeholder="Enter email (Press enter for multiple emails) "   )
                                            div.tw-flex.tw-justify-start(class="tw-max-w-[95%] tw-overflow-auto tw-pb-2")
                                                div( v-for=" (selectedEmail,emailIndex) in camp.email" :key="emailIndex" class="tw-px-2 tw-flex tw-justify-start tw-gap-1 tw-items-center tw-py-1 tw-bg-primary_brand-80 hover:tw-bg-green-600 text-white tw-text-2xs tw-font-medium tw-rounded-full tw-mr-1 tw-align-center")
                                                    button() {{ selectedEmail }}
                                                    i(class='fa-solid fa-remove fa bg-white-500 tw-cursor-pointer hover:bg-white-600 text-black ml-1 mt' @click="removeMultipleEmail(campIndex,emailIndex)")
                                            div.tw-flex.tw-justify-start.tw-text-red-600.tw-text-sm(v-if="emailError")
                                                span Please enter valid email

                                footer.tw-flex.tw-justify-end.tw-rounded-lg(class="tw-sticky tw-bottom-0 bg-white tw-w-full tw-py-4 tw-mb-0")
                                    button(class="primarycolor"  @click='postCampaignRule') 
                                        span Submit
        div#camp-modal.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-rounded-lg.tw-right-0.tw-p-4.tw-h-modal.tw-rounded-lg.tw-max-h-full(v-if="isUpdateAlertModel" style="z-index: 1020" tabindex='-1' class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9355]')
            div(class="bg-white  tw-border-[#d4d4d4] tw-border-[1px] tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px] tw-w-1/2 tw-pb-0")
                div.tw-relative.tw-bg-white.tw-rounded-lg
                    div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-4.tw-mb-4(class="tw-border-[#d5d5d5]")
                        div.tw-capitalize(class="2xl:tw-text-[20px] xs:tw-text-sm") Update Alerts     
                        div.tw-cursor-pointer(@click="hideUpdateCampModal()" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                          i(class="fa fa-solid fa-close   tw-text-[#000] tw-text-[20px]")   

                    div.tw-rounded-lg(class="tw-mb-4 tw-px-4")
                        div
                            div(v-if="dataLoader")
                                Loader   
                            <!-- div.step-content.text-xl.pb-5.font-semibold(v-if="currentActive === 1") Step 1: Alert Details -->
                            div
                                div(v-for="(camp,campIndex) in update_camp_rules" :key='campIndex' class="tw-grid tw-grid-cols-2 tw-gap-2 2xl:tw-text-base xl:tw-text-sm tw-text-[#5E5E5E]")  
                                    div
                                        div Alert Name 
                                        input.tw-px-1.tw-mr-2.tw-w-full.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-7 sm:tw-h-7 xs:tw-h-7 2xl:tw-text-sm xl:tw-text-xs tw-py-[15px] tw-border-[#B3B2B9] focus:tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' v-model="camp.alertName"  placeholder="Alert Name")
                                    div
                                        div Select Rule
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-if='campIndex==0'
                                                v-model="camp.rule_id"
                                                :options="campaignRules"
                                                limit="1"
                                                placeholder="Select rule"
                                                track-by="rule_id" 
                                                label="rule_name"
                                                :searchable="true"
                                                :show-labels="false" 
                                                open-direction="bottom"
                                                :multiple="true"
                                                :allow-empty="false"
                                            )
                                              template(slot="option" slot-scope="{ option }")
                                                input(type="checkbox", :value="option" v-model="camp.rule_id")
                                                span(class="option__title tw-ml-3") {{ option.rule_name }}
                                        <!-- button.w-7.text-white.bg-primary_brand.font-medium.rounded-lg.px-2.text-center.inline-flex.items-center.ml-3(class="hover:bg-primary_brand-80 xl:h-7 2xl:h-9 lg:h-7 xl:text-xs 2xl:text-sm lg:text-xs sm:text-xs sm:h-7 xs:h-6 xs:text-3xs")(@click="addRuleButton" ) 
                                            font-awesome-icon(icon="fa-solid fa-add") -->
                                    div
                                        div  Campaign Type
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.campaign_type"
                                                :options="campaignType"
                                                placeholder="Select Campaign Type"
                                                limit="1"
                                                track-by="label" 
                                                label="key"
                                                :searchable="true"
                                                :show-labels="false"
                                                open-direction="bottom" 
                                                :multiple="true"
                                                :allow-empty="false"
                                                @input="getCampaign(camp.campaign_type)"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.campaign_type")
                                                    span(class="option__title tw-ml-3") {{ option.key }}
                                    div
                                        div Select Campaign
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.camp_id"
                                                :options="campaign"
                                                placeholder="Select Campaign"
                                                track-by="camp_id" 
                                                label="camp_name"
                                                :searchable="true"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="true"
                                                :allow-empty="false"
                                                :close-on-select="false"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.camp_id")
                                                    span(class="option__title tw-ml-3") {{ option.camp_name }}
                                    div
                                        div Date range 
                                        div
                                            div.customMultiselectCommon
                                                multiselect(
                                                    v-model="camp.radioSelcted"
                                                    :options="dateRangeInterval"
                                                    placeholder="Select date range"
                                                    :searchable="true"
                                                    track-by="label"
                                                    label="label"
                                                    :show-labels="false" 
                                                    :multiple="false"
                                                    open-direction="bottom"
                                                    :allow-empty="false"
                                                )
                                                    
                                            <!-- div -->
                                                <!-- input(type="radio" value="0" name="date" v-model="camp.radioSelcted"  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Today -->
                                            <!-- div -->
                                                <!-- input#default-radio-1(type="radio" v-model="camp.radioSelcted" value="1"  name="date" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600") 
                                                label.font-medium.ml-2 Days -->
                                        div.customMultiselectCommon.tw-mt-2(v-if='camp?.radioSelcted?.key==1')
                                            multiselect(
                                                v-model="camp.selectedLastDate"
                                                :options="LastDate"
                                                placeholder="Select Day"
                                                :searchable="true"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="false"
                                                :allow-empty="false"

                                            )
                                    div
                                        div Select interval
                                        div
                                            div.customMultiselectCommon
                                                multiselect(
                                                    v-model="camp.intervalSelected"
                                                    :options="dayInterval"
                                                    placeholder="Select date range"
                                                    track-by="label"
                                                    label="label"
                                                    :searchable="true"
                                                    :show-labels="false" 
                                                    :multiple="false"
                                                    open-direction="bottom"
                                                    :allow-empty="false"
                                                )
                                            <!-- div
                                                input#default-radio-1(type="radio" value="daily" v-model="camp.intervalSelected"  name="today" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Daily -->
                                            div
                                                <!-- input#default-radio-1(type="radio" name="today" value="weekly" v-model="camp.intervalSelected" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Weekly -->
                                                div.customMultiselectCommon.tw-mt-2(v-if="camp.intervalSelected && camp.intervalSelected.key=='weekly'")
                                                    multiselect(
                                                        v-model="camp.selectedLastDay"
                                                        :options="LastDay"
                                                        placeholder="Select Day"
                                                        :searchable="true"
                                                        open-direction="bottom"
                                                        :show-labels="false" 
                                                        :multiple="false"
                                                        :allow-empty="false"
                                                    )
                                            div
                                                <!-- input#default-radio-1(type="radio" value="monthly" v-model="camp.intervalSelected" name="today" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600")
                                                label.font-medium.ml-2 Monthly -->

                                                div.customMultiselectCommon.tw-mt-2(v-if="camp.intervalSelected && camp.intervalSelected.key=='monthly'")
                                                    multiselect(
                                                        v-model="camp.selectedLastMonth"
                                                        :options="LastDate"
                                                        placeholder="Select Date"
                                                        :searchable="true"
                                                        open-direction="bottom"
                                                        :show-labels="false" 
                                                        :multiple="false"
                                                        :allow-empty="false"
                                                    )

                                    div
                                        div Run at
                                        div.customMultiselectCommon
                                            multiselect(
                                                v-model="camp.time"
                                                :options="runTimes"
                                                placeholder="Select Run Time"
                                                limit="1"
                                                :searchable="false"
                                                open-direction="bottom"
                                                :show-labels="false" 
                                                :multiple="true"
                                                :allow-empty="true"
                                                :close-on-select="false"
                                            )
                                                template(slot="option" slot-scope="{ option }")
                                                    input(type="checkbox", :value="option" v-model="camp.time")
                                                    span(class="option__title tw-ml-3") {{ option }}
                                        //- input.tw-px-1.tw-mb-4.tw-bg-white.tw-border-solid.tw-border.tw-border-primary_brand-80.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-7 sm:tw-h-7 xs:tw-h-7 2xl:tw-w-56 xl:tw-w-48 2xl:tw-text-sm xl:tw-text-xs focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ' type='time' v-model="camp.time"  )
                                    div
                                        div Email
                                        div
                                            input.tw-px-1.tw-mb-2.tw-bg-white.tw-border-solid.tw-border.tw-text-sm.tw-rounded.tw-block(class='3xl:tw-h-9 2xl:tw-h-8 xl:tw-h-8 sm:tw-h-7 xs:tw-h-7 tw-py-[15px] tw-w-full 2xl:tw-text-sm xl:tw-text-xs tw-border-[#B3B2B9] focus:tw-border-[#B3B2B9] focus:tw-ring-0 focus:tw-primary_brand focus:tw-outline-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed '   v-model="tempEmail"  @keyup.enter="updateMultipleEmail(campIndex)" placeholder="Enter email (Press enter for multiple emails) "   )
                                            div.tw-flex.tw-justify-start(class="tw-max-w-[95%] tw-overflow-auto tw-pb-2")
                                                div( v-for=" (selectedEmail,emailIndex) in camp.email" :key="emailIndex" class="tw-px-2 tw-flex tw-justify-start tw-gap-1 tw-items-center tw-py-1 tw-bg-primary_brand-80 hover:tw-bg-green-600 text-white tw-text-2xs tw-font-medium tw-rounded-full tw-mr-1 tw-align-center")
                                                    button() {{ selectedEmail }}
                                                    i(class='fa-solid fa-remove fa bg-white-500 tw-cursor-pointer hover:bg-white-600 text-black ml-1 mt' @click="removeMultipleUpdateEmail(campIndex,emailIndex)")
                                            div.tw-flex.tw-justify-start.tw-text-red-600.tw-text-sm(v-if="emailError")
                                                span Please enter valid email

                                footer.tw-flex.tw-justify-end.tw-rounded-lg(class="tw-sticky tw-bottom-0 bg-white tw-w-full tw-py-4 tw-mb-0")
                                    button(class="primarycolor"  @click='updateCampaignRule(update_camp_rules)') 
                                        span Submit

        div.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-right-0.tw-p-4.tw-h-modal.tw-max-h-full.tw-rounded-lg(v-if="isRuleDeleteModel" style ="z-index:1020" tabindex='-1' ref="ruleModal" class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9397]' )
          div(class="bg-white tw-border-[#d4d4d4] tw-border-[1px] tw-fixed tw-top-10 tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px]  tw-w-[500px] tw-pb-0")
              div.tw-relative.tw-bg-white.tw-rounded-lg
                  div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-3.tw-mb-4(class="tw-border-[#d5d5d5]")
                      div.tw-capitalize(class="2xl:tw-text-[16px] xs:tw-text-sm tw-text-[#5e5e5e]") Delete Rule
                      div.tw-cursor-pointer(@click="isRuleDeleteModel = !isRuleDeleteModel" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                          i(class="fa fa-solid fa-close  tw-text-[#000] tw-text-[20px]")   
                  div(class="tw-my-4 tw-px-4 tw-rounded-lg")
                    div.tw-flex.tw-gap-3.tw-items-center.tw-my-4
                      div(class="delete-alert tw-text-center tw-rounded-full tw-px-2 tw-mr-3") ⚠
                      div(class="tw-text-[16px] tw-text-primary_brand ") You are going to delete this Rule. Are you sure ?
                    div.tw-float-right.tw-my-4
                      button(class="primarycolor tw-mx-2" @click="isRuleDeleteModel = !isRuleDeleteModel") No, Keep It.
                      button(class=" primarycolor tw-bg-[#f86c6b] hover:tw-bg-[#f58181]" @click="deleteAlertRules") Yes, Delete!

        div.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-right-0.tw-p-4.tw-h-modal.tw-max-h-full.tw-rounded-lg(v-if="isAlertDeleteModel" style ="z-index:1020" tabindex='-1' ref="ruleModal" class='md:tw-inset-0 md:tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-[#888b9397]' )
          div(class="bg-white tw-border-[#d4d4d4] tw-border-[1px] tw-fixed tw-top-10 tw-shadow-[0_2px_4px_0_rgba(0,0,0,.25)] tw-rounded-[10px]  tw-w-[500px] tw-pb-0")
              div.tw-relative.tw-bg-white.tw-rounded-lg
                  div.tw-rounded-t-lg.tw-border-solid.tw-border-b.tw-mx-5.tw-py-3.tw-mb-4(class="tw-border-[#d5d5d5]")
                      div.tw-capitalize(class="2xl:tw-text-[16px] xs:tw-text-sm tw-text-[#5e5e5e]") Delete Alert
                      div.tw-cursor-pointer(@click="isAlertDeleteModel = !isAlertDeleteModel" class="tw-bg-[#e7eeee] tw-flex tw-items-center tw-py-[8px] tw-px-[10px] tw-rounded-full tw-absolute tw-top-[-20px] tw-right-[-18px]") 
                          i(class="fa fa-solid fa-close  tw-text-[#000] tw-text-[20px]")   
                  div(class="tw-my-4 tw-px-4 tw-rounded-lg")
                    div.tw-flex.tw-gap-3.tw-items-center.tw-my-4
                      div(class="delete-alert tw-text-center tw-rounded-full tw-px-2 tw-mr-3") ⚠
                      div(class="tw-text-[16px] tw-text-primary_brand ") You are going to delete this Alert. Are you sure ?
                    div.tw-float-right.tw-my-4
                      button(class="primarycolor tw-mx-2" @click="isAlertDeleteModel = !isAlertDeleteModel") No, Keep It.
                      button(class=" primarycolor tw-bg-[#f86c6b] hover:tw-bg-[#f58181]" @click="deleteCampaignRules") Yes, Delete!
</template>

<script>
import moment from "moment";
// import Toast from "@/components/Toast/Toast.vue";
import Loader from "../../Components/Loader.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "Alert",
  components: {
    Loader,
    Multiselect,
    // Toast,
  },
  data() {
    return {
      isRuleModel: false,
      isUpdateRuleModel: false,
      isAlertModel: false,
      isUpdateAlertModel: false,
      isRuleDeleteModel: false,
      isAlertDeleteModel: false,
      isRuleTableDataLoader: false,
      isCampaignTableDataLoader: false,
      isAlertCampReportLoader: false,
      dataLoader: false,
      dataLoader1: false,
      campLoader: false,
      campaignTableHeader: [],
      campaignTableData: [],
      categoryWiseTableData: "",
      rulesTableData: [],
      rulesTableHeader: [],
      intervalSelected: "1",
      ruleId: [],
      runTimes: [],
      rule_id: "",
      tempEmail: "",
      emailError: false,
      metrics: [],
      headersList: [],
      campaignRules: [],
      postCampaign: [],
      dropdownOptions2: [
        "Greater Than",
        "Greater Equal",
        "Equal",
        "Less Equal",
        "Less Than",
      ],
      updateDropdownOptions2: [
        {
          key: ">",
          label: "Greater Than",
        },
        {
          key: ">=",
          label: "Greater Equal",
        },
        {
          key: "==",
          label: "Equal",
        },
        {
          key: "<=",
          label: "Less Equal",
        },
        {
          key: "<",
          label: "Less Than",
        },
      ],
      ruleModal: undefined,
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      intervalOptions: ["Daily", "Weekly"],
      LastDate: [
        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
        22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      LastDay: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      dateRangeInterval: [
        {
          key: 0,
          label: "Today",
        },
        {
          key: 1,
          label: "Days",
        },
      ],
      dayInterval: [
        {
          key: "daily",
          label: "Daily",
        },
        {
          key: "weekly",
          label: "Weekly",
        },
        {
          key: "monthly",
          label: "Monthly",
        },
      ],
      rules: [
        {
          rule_name: "",
          conditions: [
            {
              metric: "",
              operation: "",
              value: null,
            },
          ],
        },
      ],
      updateRules: [
        {
          rule_name: "",
          rule_id: "",
          conditions: [],
        },
      ],
      alertDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      alertCampReports: {
        headers: [],
        data: [],
      },
      camp_rules: [
        {
          rule_id: [],
          campaign_id: [],
          campaign_name: [],
          campaign_type: [],
          radioSelcted: "",
          selectedLastDate: "",
          selectedLastDay: "",
          selectedLastMonth: "",
          interval: "",
          time: [],
          alertName: "",
          email: [],
        },
      ],
      update_camp_rules: [],
      campaign: [],
      campaignType: [],
      failedCampaignReports: {
        headers: [],
        data: [],
      },
      selectedChannel: [],
      channelList: [],
      deletedRuleID: "",
      // currentActive: 1,
      // circles: Array(2).fill(null),
    };
  },
  computed: {
    progressWidth() {
      return ((this.currentActive - 1) / (this.circles.length - 1)) * 100 + "%";
    },
  },
  created() {
    const today = new Date();
    const yesterday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
    const monthStartDate = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate() + 0
    );
    const thisMonthStartDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    const thisMonthEndDate = new Date();
    const lastMonthStartDate = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );
    const lastMonthEndDate = new Date(today.getFullYear(), today.getMonth(), 0);
    const thisYearStartDate = new Date(today.getFullYear(), 0, 1);
    const thisYearEndDate = new Date(today.getFullYear(), 11, 31);
    const lastYearStartDate = new Date(today.getFullYear() - 1, 0, 1);
    const lastYearEndDate = new Date(today.getFullYear() - 1, 11, 31);
    const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
    const quarterStartDate = new Date(
      today.getFullYear(),
      quarterStartMonth,
      1
    );

    // Calculate the first day of the current week (Sunday)
    const firstDayOfCurrentWeek = new Date(today);
    firstDayOfCurrentWeek.setDate(today.getDate() - today.getDay());

    // Calculate the last day of the previous week (Saturday)
    const lastDayOfLastWeek = new Date(firstDayOfCurrentWeek);
    lastDayOfLastWeek.setDate(firstDayOfCurrentWeek.getDate() - 1);

    // Calculate the first day of last week (Sunday)
    const firstDayOfLastWeek = new Date(lastDayOfLastWeek);
    firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6);

    this.customRanges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      Month: [monthStartDate, thisMonthEndDate],
      "Last Week": [firstDayOfLastWeek, lastDayOfLastWeek],
      "Last month": [lastMonthStartDate, lastMonthEndDate],
      "Last Year": [lastYearStartDate, lastYearEndDate],
      MTD: [thisMonthStartDate, today],
      QTD: [quarterStartDate, today],
      YTD: [thisYearStartDate, today],
    };
  },
  mounted() {
    // if (localStorage.campStatus) localStorage.removeItem("campStatus");
    // if (localStorage.selectedCampaign)
    //     localStorage.removeItem("selectedCampaign");
    // if (localStorage.dateRange) localStorage.removeItem("dateRange");
    // this.getCampaignTableData("");
    this.getChannelList();
  },
  methods: {
    dataAPIS() {
      this.getAlertRules();
      this.getCampaignRule();
      if (this.selectedChannel.key == "amazon") {
        this.getUpdatedAMSRefreshData();
      }
      this.checkStatus();
      this.getAlertReports();
    },
    handleChannel() {
      this.dataAPIS();
    },
    handleDateChange() {
      this.dataAPIS();
    },
    addButton() {
      // this.ruleModal.show();
      this.camp_rules = [
        {
          rule_id: [],
          campaign_id: [],
          campaign_name: [],
          campaign_type: [],
          radioSelcted: [],
          selectedLastDate: [],
          selectedLastDay: [],
          selectedLastMonth: [],
          interval: "",
          time: [],
          alertName: "",
          email: [],
        },
      ];
      this.isRuleModel = true;
      // this.getAlertRules();
    },
    addCampButton() {
      this.camp_rules = [
        {
          rule_id: [],
          campaign_id: [],
          campaign_name: [],
          campaign_type: [],
          radioSelcted: "",
          selectedLastDate: "",
          selectedLastDay: "",
          selectedLastMonth: "",
          interval: "",
          time: [],
          alertName: "",
          email: [],
        },
      ];
      this.getCampaignRule();
      this.isAlertModel = true;
      // this.getCampaign();
    },
    addItem(index) {
      this.rules[index].conditions.push({
        metric: "",
        operation: "",
        value: null,
      });
    },
    removeItem(ruleIndex, conditionIndex) {
      this.rules[ruleIndex].conditions.splice(conditionIndex, 1);
    },
    // removeUpdateItem(ruleIndex, conditionIndex) {
    //   this.updateRules[ruleIndex].conditions.splice(conditionIndex, 1);
    // },

    addRules() {
      this.rules.push({
        rule_name: "",
        conditions: [
          {
            metric: "",
            operation: "",
            value: null,
          },
        ],
      });
    },
    // addRuleButton() {
    //     this.campModal.hide();
    //     this.ruleModal.show();
    // },
    handleBack() {
      this.$router.push("campaign-summary");
    },
    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    formatNumber(num) {
      if (isNaN(num)) return num;
      let num1 = Number(num).toFixed(2);
      let num2 = Number(num1).toLocaleString();
      return num2;
    },
    formateDateRange(timestamp) {
      return moment(timestamp).format("lll");
    },
    multipleEmail(campIndex) {
      if (!this.validEmail(this.tempEmail)) {
        this.emailError = true;
        return false;
      }
      this.emailError = false;
      this.camp_rules[campIndex].email.push(this.tempEmail);
      this.tempEmail = "";
    },
    updateMultipleEmail(campIndex) {
      if (!this.validEmail(this.tempEmail)) {
        this.emailError = true;
        return false;
      }
      this.emailError = false;
      this.update_camp_rules[campIndex].email.push(this.tempEmail);
      this.tempEmail = "";
    },
    removeMultipleEmail(campIndex, emailIndex) {
      this.camp_rules[campIndex].email.splice(emailIndex, 1);
    },
    removeMultipleUpdateEmail(campIndex, emailIndex) {
      this.update_camp_rules[campIndex].email.splice(emailIndex, 1);
    },
    hideRuleModal() {
      this.isRuleModel = false;
    },
    hideUpdateRuleModal() {
      this.isUpdateRuleModel = false;
    },
    hideCampModal() {
      this.isAlertModel = false;
    },
    hideUpdateCampModal() {
      this.isUpdateAlertModel = false;
    },
    checkStatus() {
      if (this.selectedChannel.key == "amazon") {
        this.intervalID = setInterval(this.getUpdatedAMSRefreshData, 9000);
      }
    },

    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      //   var search = require();
      //   var clear = require("@/assets/clear.png");
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: [[sortCol, "desc"]],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
         <div class='search_icon'>
              <img src='/Icons_SVG/Search.svg' width='20' />
            </div>
        `);
    },
    getChannelList() {
      const url = "/api/slate/platformstatus";
      this.$http
        .get(url)
        .then((res) => {
          this.channelList = res.data.data.channelslist;
          this.selectedChannel = this.channelList[0];
          this.dataAPIS();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAlertRules() {
      this.dataLoader = true;
      this.rulesTableData = "";
      this.isRuleTableDataLoader = true;
      let url = "/api/v2/slate/alert_rules?channel=" + this.selectedChannel.key;
      this.$http
        .get(url)
        .then((res) => {
          const resData = res.data;
          this.isRuleTableDataLoader = false;
          this.metrics = resData.data.metrices;
          this.rulesTableHeader = resData.data.headers;
          this.rulesTableData = resData.data.dashboard_data;
          this.runTimes = resData.data.run_time_options;
          this.rulesTableHeader.push({ key: "action", label: "Action" });
          if (resData.data.rules.length)
            this.campaignRules = resData.data.rules;
          this.$nextTick(() => {
            this.processTable("#ruleTable");
          });
          this.dataLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
          this.isRuleTableDataLoader = false;
        });
    },
    refrencePageData() {
      this.dataLoader1 = true;
      let url = "/api/amazon/RefreshAmsData";
      this.$http
        .post(url, {})
        .then((res) => {
          this.dataLoader1 = false;
          this.getUpdatedAMSRefreshData();
          this.checkStatus();
        })
        .catch((err) => {
          console.log(err);

          this.dataLoader1 = false;
        });
    },
    handleDeleteRule(deleteRuleId) {
      this.isRuleDeleteModel = true;
      this.deletedRuleID = deleteRuleId;
    },
    parseConditionString(conditionStr) {
      const regex = /(\w+)\s*(>=|<=|>|<|==|!=)\s*(\d+)/g;
      const result = [];
      let match;
      while ((match = regex.exec(conditionStr)) !== null) {
        const operationKey = match[2];

        // Find the matching object from updateDropdownOptions2
        const operationObj = this.updateDropdownOptions2.find(
          (op) => op.key === operationKey
        );

        result.push({
          metric: match[1],
          operation: operationObj || { key: operationKey, label: operationKey },
          value: Number(match[3]),
        });
      }
      return result;
    },
    handleUpdateRule(rule) {
      this.isUpdateRuleModel = true;
      this.updateRules.rule_name = rule.rule_name;
      this.updateRules.rule_id = rule.rule_id;
      const parsedConditions = this.parseConditionString(rule.conditions);
      this.$set(this.updateRules, "conditions", parsedConditions);
    },
    updateAlertRules() {
      const user = localStorage.getItem("reviewUserData");
      const token = JSON.parse(user);
      const url = "/api/v2/slate/alert_rules";
      const payload = {
        channel: this.selectedChannel.key,
        rule_id: this.updateRules.rule_id,
        rule_name: this.updateRules.rule_name,
        conditions: this.updateRules.conditions.map((condition) => ({
          metric: condition.metric,
          operation: condition.operation?.label || condition.operation,
          value: condition.value.toString(),
        })),
      };
      fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          TOKEN: token.data.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          this.isUpdateRuleModel = false;
          this.getAlertRules();
          this.getCampaignRule();
          this.dataLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
        });
    },
    deleteAlertRules() {
      this.dataLoader = true;
      let url = "/api/v2/slate/alert_rules";
      let payload = {
        rule_id: this.deletedRuleID,
        channel: this.selectedChannel.key,
      };
      this.$http
        .delete(url, { body: payload })
        .then((res) => {
          this.isRuleDeleteModel = false;
          this.getAlertRules();
          this.dataLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
        });
    },
    getCampaignRule() {
      this.dataLoader1 = true;
      this.isCampaignTableDataLoader = true;
      this.campaignType = [];
      this.campaignTableData = [];
      this.campaignTableHeader = [];
      let url =
        "/api/v2/slate/campaign_alert_rules?channel=" +
        this.selectedChannel.key;
      this.$http
        .get(url)
        .then((res) => {
          const resData = res.data;
          this.dataLoader1 = false;
          this.campaignType = resData.data.campaign_types;
          if (this.campaignType.length != 0) {
            this.campaignType.unshift({
              key: "ALL",
              label: "all",
            });
          }
          this.campaignTableHeader = resData.data.headers;
          this.campaignTableData = resData.data.campaign_rules;
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.campaignTableData.length > 0) {
                this.processTable("#campaignRuleTable");
              }
            }, 100);
          });
          this.isCampaignTableDataLoader = false;
          this.dataLoader1 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader1 = false;
          this.isCampaignTableDataLoader = false;
        });
    },
    getUpdatedAMSRefreshData() {
      let intervalTempId = this.intervalID;
      this.viewUpdatedAMSRefreshData = "";
      let url =
        "/api/v2/slate/GetRefreshAmsDataStatus?channel=" +
        this.selectedChannel.key;
      this.$http
        .get(url)
        .then((res) => {
          this.viewUpdatedAMSRefreshData = res.data.data;
          if (
            this.viewUpdatedAMSRefreshData.refresh_status == "failed" ||
            this.viewUpdatedAMSRefreshData.refresh_status == null
          ) {
            clearInterval(intervalTempId);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleDeleteAlert(deleteAlertId) {
      this.isAlertDeleteModel = true;
      this.deletedAlertID = deleteAlertId;
    },
    async handleUpdateAlert(alert) {
      this.update_camp_rules = [];

      const selectedRules = alert?.rule_id?.map((ruleId) =>
        this.campaignRules?.find((rule) => rule?.rule_id === ruleId)
      );
      const selectedCampaignTypes = alert?.campaign_type?.map((type) =>
        this.campaignType?.find(
          (ct) => ct?.label.toLowerCase() === type.toLowerCase()
        )
      );
      await this.getCampaign(selectedCampaignTypes);
      const selectedCampaigns = alert?.campaign_id
        ?.map((id) =>
          this.campaign?.find(
            (c) => c.camp_id?.toLowerCase() === id.toLowerCase()
          )
        )
        .filter(Boolean);
      this.isUpdateAlertModel = true;
      const updatedRule = {
        alertName: alert.alert_name,
        account_id: alert.account_id,
        camp_id: selectedCampaigns,
        campaign_name: selectedCampaigns.camp_name,
        campaign_type: selectedCampaignTypes,
        rule_id: selectedRules,
        email: alert.email,
        radioSelcted: this.dateRangeInterval?.find(
          (opt) => opt?.key === alert.data_duration
        ),
        selectedLastDate: this.LastDate?.find(
          (opt) => opt?.key == alert.day_of_month
        ),
        intervalSelected: this.dayInterval?.find(
          (opt) => opt?.key === alert.interval
        ),
        selectedLastDay: alert.day_of_week,
        selectedLastMonth: alert.day_of_month,
        time: alert.run_at,
        rules: alert.rules || [],
        created_at: alert.created_at,
        status: alert.status,
        id: alert.alert_id,
        rule_names: alert.rule_names,
      };

      this.update_camp_rules = [updatedRule];
    },
    deleteCampaignRules() {
      this.dataLoader = true;
      let url = "/api/v2/slate/campaign_alert_rules";
      let payload = {
        channel: this.selectedChannel.key,
        alert_id: this.deletedAlertID,
      };
      this.$http.delete(url, { body: payload }).then((res) => {
        this.isAlertDeleteModel = false;
        this.getCampaignRule();
        location.reload();
        this.dataLoader = false;
      });
    },
    getAlertReports() {
      this.dataLoader = true;
      this.isAlertCampReportLoader = true;
      $("#reportsTable").DataTable().destroy();

      this.alertCampReports.headers = [];
      this.alertCampReports.data = [];
      const url = "/api/v2/slate/alertname_list?";
      const payload = {
        channel: this.selectedChannel.key,
        start_date: moment(this.alertDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.alertDateRange.endDate).format("YYYY-MM-DD"),
      };

      this.$http
        .get(url, {
          params: payload,
        })
        .then((res) => {
          this.alertCampReports.headers = res.data.data.headers;
          this.alertCampReports.data = res.data.data.report_names;
          this.$nextTick(() => {
            this.processTable("#reportsTable");
          });
          this.dataLoader = false;
          this.isAlertCampReportLoader = false;
        })
        .catch((err) => {
          this.dataLoader = false;
          this.isAlertCampReportLoader = false;
          console.log(`Error in getting alert reports::${err}`);
        });
    },
    // getFailedCampaigns(report) {
    //   this.dataLoader = true;

    //   const url = "/api/amazon/alert/reports";
    //   const payload = {
    //     start_date: moment(this.alertDateRange.startDate).format("YYYY-MM-DD"),
    //     end_date: moment(this.alertDateRange.endDate).format("YYYY-MM-DD"),
    //     report_name: report,
    //   };
    //   this.failedCampModalTitle = `Failed Campaigns - ${report}`;

    //   this.$http
    //     .get(url, { params: payload })
    //     .then((res) => {
    //       this.failedCampaignReports.headers = res.data.data.headers;
    //       this.failedCampaignReports.data = res.data.data.data;
    //       this.dataLoader = false;
    //       this.failedCampModal.show();
    //       this.$nextTick(() => {
    //         this.processTable("#failedCampTable", 0, "300px");
    //       });
    //     })
    //     .catch((err) => {
    //       this.dataLoader = false;
    //       console.log(`Error in getting failed campaigns::${err}`);
    //     });
    // },
    postAlertRules() {
      this.dataLoader = true;
      let url = "/api/v2/slate/alert_rules";

      if (!this.rules[0].rule_name) {
        // this.$toast.error("Rule name can't be empty", {
        //   position: "bottom-center",
        //   timeout: 5000,
        //   closeOnClick: true,
        //   pauseOnFocusLoss: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   draggablePercent: 0.6,
        //   showCloseButtonOnHover: false,
        //   hideProgressBar: true,
        //   closeButton: "button",
        //   icon: true,
        //   rtl: false,
        // });
        return;
      }

      let payload = {
        channel: this.selectedChannel.key,
        rules: [],
      };

      if (this.rules[0].conditions.length > 1) {
        this.rules[0].conditions.forEach((condition, index) => {
          if (!condition.metric || !condition.operation || !condition.value) {
            this.rules[0].conditions.splice(index, 1);
          }
        });
      } else {
        if (
          !this.rules[0].conditions[0].metric ||
          !this.rules[0].conditions[0].operation ||
          !this.rules[0].conditions[0].value
        ) {
          //   this.$toast.error("Rule properties can't be empty", {
          //     position: "bottom-center",
          //     timeout: 5000,
          //     closeOnClick: true,
          //     pauseOnFocusLoss: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     draggablePercent: 0.6,
          //     showCloseButtonOnHover: false,
          //     hideProgressBar: true,
          //     closeButton: "button",
          //     icon: true,
          //     rtl: false,
          //   });
          return;
        }
      }

      payload["rules"] = this.rules;
      this.$http
        .post(url, payload)
        .then((res) => {
          // alert("Rule Added Successfully");
          this.dataLoader = false;
          this.rules = [
            {
              rule_name: "",
              conditions: [
                {
                  metric: "",
                  operation: "",
                  value: null,
                },
              ],
            },
          ];
          //   this.$toast.success("Added Successfully", {
          //     position: "bottom-center",
          //     timeout: 5000,
          //     closeOnClick: true,
          //     pauseOnFocusLoss: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     draggablePercent: 0.6,
          //     showCloseButtonOnHover: false,
          //     hideProgressBar: true,
          //     closeButton: "button",
          //     icon: true,
          //     rtl: false,
          //   });
          this.isRuleModel = false;
          this.getAlertRules();
          // this.closeRuleModal();
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
        });
    },
    getCampaign(type) {
      this.dataLoader = true;
      let key = [];
      this.campaign = [];

      if (type.length) {
        if (type[0].label === "all") {
          for (let data of this.campaignType) {
            if (data.label !== "all") key.push(data.label);
          }
        } else {
          for (let data of type) {
            key.push(data.label);
          }
        }
      } else {
        this.dataLoader = false;
        return Promise.resolve();
      }

      let url = "/api/v2/slate/campaigns_list";
      const payload = {
        report_type: key.toString(),
        channel: this.selectedChannel.key,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
      };

      return this.$http
        .post(url, payload)
        .then((res) => {
          const resData = res.data.data;
          this.campaign = resData.data || [];
          this.dataLoader = false;

          if (this.campaign.length) {
            this.campaign.unshift({
              camp_id: "all",
              camp_name: "ALL",
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching campaigns:", err);
          this.dataLoader = false;
        });
    },
    postCampaignRule() {      
      // console.log("check the value ", this.camp_rules);

      if (!this.camp_rules[0].alertName || !this.camp_rules[0].rule_id.length || !this.camp_rules[0].campaign_type || !this.camp_rules[0].camp_id  || !this.camp_rules[0].radioSelcted || !this.camp_rules[0].intervalSelected || !this.camp_rules[0].time || !this.camp_rules[0].email ) {
        this.$bvToast.toast("Please Fill the Values", {
          variant: "danger",
          position: "top-center",
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
        return false;
      }
      this.postCampaign = [];
      this.dataLoader = true;

      for (let Element of this.camp_rules) {
        let temp = {
          rule_id: Element?.rule_id?.map((value) => {
            return value.rule_id;
          }),
          campaign_id:
            Element?.camp_id[0]?.camp_id == "all"
              ? []
              : Element?.camp_id?.map((value) => {
                  return value.camp_id;
                }),
          campaign_name:
            Element?.camp_id[0]?.camp_name == "ALL"
              ? []
              : Element?.camp_id?.map((value) => {
                  return value.camp_name;
                }),
          campaign_type:
            Element?.campaign_type[0]?.label == "all"
              ? []
              : Element?.campaign_type?.map((value) => {
                  return value.label;
                }),
          interval: Element?.intervalSelected?.key,
          run_at: Element?.time,
          alert_name: Element?.alertName,
          email: Element?.email,
          data_duration:
            Element?.radioSelcted?.key == 0 ? 0 : Element?.selectedLastDate,
        };
        if (this.tempEmail) {
          if (!this.validEmail(this.tempEmail)) {
            this.emailError = true;
            this.dataLoader = false;
            return false;
          }
          Element.email.push(this.tempEmail);
        }

        if (temp.interval == "weekly") {
          Object.assign(temp, { day_of_week: Element.selectedLastDay });
        }
        if (temp.interval == "monthly") {
          Object.assign(temp, { day_of_month: Element.selectedLastMonth });
        }
        this.postCampaign.push(temp);
      }
      let url = "/api/v2/slate/campaign_alert_rules";

      let payload = {
        channel: this.selectedChannel.key,
        camp_rules: this.postCampaign,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.camp_rules = [
            {
              rule_id: [],
              campaign_id: [],
              campaign_name: [],
              campaign_type: [],
              radioSelcted: "",
              selectedLastDate: "",
              selectedLastDay: "",
              selectedLastMonth: "",
              interval: "",
              time: [],
              alertName: "",
              email: [],
            },
          ];
          //   this.$toast.success("Rule Added Successfully", {
          //     position: "bottom-center",
          //     timeout: 5000,
          //     closeOnClick: true,
          //     pauseOnFocusLoss: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     draggablePercent: 0.6,
          //     showCloseButtonOnHover: false,
          //     hideProgressBar: true,
          //     closeButton: "button",
          //     icon: true,
          //     rtl: false,
          //   });
          // this.hideCampModal();
          // this.getCampaignRule();
          this.isAlertModel = false;
          location.reload();
          this.dataLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
        });
    },
    updateCampaignRule(updatedData) {
      const url = "/api/v2/slate/campaign_alert_rules";

      const payload = {
        channel: this.selectedChannel.key,
        alert_id: updatedData[0]?.id,
        alert_name: updatedData[0]?.alertName,
        account_id: updatedData[0]?.account_id,
        campaign_id: updatedData[0]?.camp_id?.map((camp) => camp.camp_id),
        campaign_type: updatedData[0]?.campaign_type?.map((type) => type.label),
        campaign_name: updatedData[0]?.camp_id?.map((camp) => camp.camp_name),
        rule_id: updatedData[0]?.rule_id?.map((rule) => rule.rule_id),
        email: updatedData[0]?.email,
        data_duration:
          updatedData[0]?.radioSelcted?.key == 0
            ? 0
            : updatedData[0]?.selectedLastDate,
        interval: updatedData[0]?.intervalSelected?.key,
        run_at: updatedData[0]?.time,
        day_of_week: updatedData[0]?.selectedLastDay,
        day_of_month: updatedData[0]?.selectedLastMonth,
      };
      this.$http
        .put(url, payload)
        .then((res) => {
          this.isUpdateAlertModel = false;
          this.getCampaignRule();
          this.dataLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.dataLoader = false;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.customMultiselectCommon .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselectCommon span.multiselect__single {
  display: flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customMultiselectCommon .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  font-family: "poppins";
  overflow-y: auto !important;
}

.customMultiselectCommon .multiselect__tags .multiselect__single {
  font-size: 14px !important;
}

.customMultiselectCommon .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselectCommon
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
  font-size: 14px !important;
}

/* width */
.customMultiselectCommon ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
  display: none;
}

/* Track */
.customMultiselectCommon ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselectCommon ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselectCommon ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselectCommon .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}
</style>
<style scoped>
.dataTables_wrapper {
  display: none;
}

:root {
  --line-border-empty: #e0e0e0;
  --progress-zIndex: -1;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.contaienr {
  text-align: center;
}

.progress-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  max-width: 100%;
  position: relative;
  width: 350px;
}

.progress-container::before {
  background-color: var(--line-border-empty);
  content: "";
  height: 2px;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  z-index: -1;
}

.progress {
  background-color: #065559;
  height: 2px;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s ease;
  z-index: var(--progress-zIndex);
}

.circle {
  align-items: center;
  background-color: white;
  border: 2px solid #065559;
  border-radius: 50%;
  color: #065559;
  display: flex;
  height: 30px;
  justify-content: center;
  transition: 0.4s ease;
  width: 30px;
  z-index: 1;
}

.circle.active {
  border-color: #065559;
  background-color: #065559;
  color: #fff;
}

.stepbtn:active {
  transform: scale(0.98);
}

.stepbtn:focus {
  outline: 0;
}

.stepbtn:disabled {
  cursor: not-allowed;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 20px;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.delete-alert {
  background-color: #ffecec !important;
  color: var(--red);
  font-size: 30px;
  width: 45px;
  height: 45px;
}
</style>
